import { Dialog, Transition } from '@headlessui/react';
import { useEffect } from 'react';
import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { IconX } from '@tabler/icons-react';
import ImageComponent from '../../utils/ImageComponent';

export default function EditTrxPembelian({
  isOpenEditTrx,
  submitPembelian,
  editTrxPembelian,
  setKarat,
  setKondisiBarang,
  berat,
  harga_beli,
  setHargaBeli,
  setJenisKategoriIdBase,
  setIsChange,
  setBerat,
  idEditPembelian,
  is_change_harga,
  closeModalEditTrx,
  karat,
  gambar,
  setGambar,
  isSelected,
  setIsSelected,
}) {
  // console.log('idEditPembelian::: ', idEditPembelian.gambar[0].asli);
  const [openImage, setOpenImage] = useState(false);
  const [load, setLoad] = useState(false);

  function fake(params) {}
  const [jenisKategori, setJenisKategori] = useState([]);
  const [selectImage, setSelectImage] = useState([]);

  const handleImageChange = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);
    setIsSelected(true);
    if (selectImage.length < 1) {
      const reader1 = new FileReader();
      reader1.addEventListener('load', function () {
        setGambar(reader1.result.split(',')[1]);
      });
      reader1.readAsDataURL(selectedFiles[0]);
    }
    const imagesArray = selectedFilesArray.map((file) => {
      return URL.createObjectURL(file);
    });
    // setSelectImage((previousImages) => previousImages.concat(imagesArray));
    setSelectImage(imagesArray);
    // FOR BUG IN CHROME
    event.target.value = '';
  };

  const navigate = useNavigate();
  const [kategori, setKategori] = useState([]);
  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          // console.log('res::: ', res);
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, [navigate]);

  async function selectJenisKategori(id) {
    await http
      .get(`/jenis/kategori/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategori(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleCheckbox() {
    setIsChange(!is_change_harga);
  }

  useEffect(() => {
    if (isOpenEditTrx === false) {
      setIsChange(false);
    }
  }, [isOpenEditTrx]);
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const karatOption = [
    { karat: 16 },
    { karat: 17 },
    { karat: 18 },
    { karat: 19 },
    { karat: 20 },
    { karat: 21 },
    { karat: 22 },
    { karat: 23 },
    { karat: 24 },
  ];

  const kondisiBarangOption = [{ kondisi: 'Ready Jual' }, { kondisi: 'Service' }, { kondisi: 'Rongsok' }];

  return (
    <>
      <Transition appear show={isOpenEditTrx} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={fake}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-700 p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title as="h3" className="text-lg font-semibold leading-6 text-slate-900 dark:text-slate-100 border-b border-slate-100 dark:border-slate-800 pb-3 mb-4">
                    Edit Transaksi Pembelian: <span className="text-amber-600 dark:text-amber-500 font-bold tracking-wide">{idEditPembelian.kode_trx}</span>
                  </Dialog.Title>
                  {openImage && isOpenEditTrx && (
                    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20  flex flex-col items-center justify-center">
                      <div
                        onClick={() => setOpenImage(false)}
                        className={'absolute top-52 right-7 lg:top-16 lg:right-[280px] md:right-[120px] md:top-28 '}
                      >
                        <div className="bg-white p-2 rounded-full cursor-pointer hover:bg-white/50">
                          <IconX />
                        </div>
                      </div>
                      <div>
                        {!load && (
                          <div className="max-w-[48px] max-h-[48px]  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                        )}
                        <img
                          onLoad={() => setLoad(true)}
                          width={''}
                          className={'lg:w-[700px] md:w-[500px] w-[350px] scale-50'}
                          height={''}
                          src={
                            idEditPembelian.gambar === null ? '' : `${imageBaseUrl}${idEditPembelian.gambar[0].asli}`
                          }
                        />
                      </div>
                    </div>
                  )}
                  <form action="" onSubmit={editTrxPembelian}>
                    <div className="mb-5">
                      <label
                        htmlFor="kategori"
                        className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300"
                      >
                        Pilih Kategori
                        <span className="text-red-500 dark:text-red-400 font-normal ml-2">
                          (Saat ini: {idEditPembelian.jenis_kategori?.kategori?.nama_kategori})
                        </span>
                      </label>
                      <select
                        onChange={(e) => selectJenisKategori(e.target.value)}
                        name="KategoriName"
                        className="w-full p-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                      >
                        <option value="">Pilih Kategori</option>
                        {kategori.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nama_kategori}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-5">
                      <label
                        htmlFor="kategori"
                        className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300"
                      >
                        Pilih Jenis
                        <span className="text-red-500 dark:text-red-400 font-normal ml-2">(Saat ini: {idEditPembelian.jenis_kategori?.nama_jenis})</span>
                      </label>
                      <select
                        onChange={(e) => setJenisKategoriIdBase(e.target.value)}
                        className="w-full p-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                      >
                        <option value="">Pilih Jenis</option>
                        {jenisKategori.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nama_jenis}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                      <div>
                        <label htmlFor="berat" className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300">
                          Berat <span className="text-slate-400 font-normal ml-1">(Gram)</span>
                        </label>
                        <input
                          type="number"
                          id="berat"
                          name="berat"
                          autoComplete="off"
                          defaultValue={berat || ''}
                          onChange={(e) => setBerat(e.target.value)}
                          className="w-full p-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                        />
                      </div>
                      <div>
                        <label htmlFor="karat" className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300">
                          Karat
                          <span className="text-red-500 dark:text-red-400 font-normal ml-2">(Saat ini: {idEditPembelian.karat}K)</span>
                        </label>
                        <select
                          onChange={(e) => setKarat(e.target.value)}
                          id={'karat'}
                          name="karat"
                          className="w-full p-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                        >
                          <option value="">Pilih Karat</option>
                          {karatOption.map((item, i) => (
                            <option key={i} value={item.karat}>
                              {item.karat}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="w-full mb-5">
                      <label
                        htmlFor="kondisi_barang"
                        className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300"
                      >
                        Kondisi Barang
                        <span className="text-red-500 dark:text-red-400 font-normal ml-2">(Saat ini: {idEditPembelian.kondisi_barang})</span>
                      </label>
                      <select
                        onChange={(e) => setKondisiBarang(e.target.value)}
                        id={'kondisi_barang'}
                        name="kondisi_barang"
                        className="w-full p-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                      >
                        <option value="">Pilih Kondisi Barang</option>
                        {kondisiBarangOption.map((item, i) => (
                          <option key={i} value={item.kondisi}>
                            {item.kondisi}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-5 p-4 rounded-lg bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700 shadow-sm">
                      <label
                        htmlFor="harga_beli"
                        className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300"
                      >
                        Total Harga{' '}
                        <span className="text-amber-600 dark:text-amber-500 font-bold ml-2">
                          Rp{' '}
                          {numberWithCommas(
                            idEditPembelian?.harga_beli === undefined ? '0' : idEditPembelian?.harga_beli,
                          )}
                        </span>
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span className="text-slate-500 dark:text-slate-400 sm:text-sm">Rp</span>
                        </div>
                        <input
                          type="number"
                          id="harga_beli"
                          defaultValue={harga_beli || ''}
                          name="harga_beli"
                          onChange={(e) => setHargaBeli(e.target.value)}
                          className="pl-10 w-full p-2.5 bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600/80 rounded-lg text-sm text-slate-700 dark:text-slate-200 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 transition-colors shadow-sm"
                          required
                        />
                      </div>
                      <div className="mt-3 flex items-center">
                        <input
                          checked={is_change_harga}
                          onChange={handleCheckbox}
                          type="checkbox"
                          id="nominal_harga"
                          className="w-4 h-4 text-amber-500 bg-white border-slate-300 rounded focus:ring-amber-500 dark:focus:ring-amber-600 dark:ring-offset-slate-800 focus:ring-2 dark:bg-slate-700 dark:border-slate-600 cursor-pointer"
                        />
                        <label className="ml-2 text-sm font-medium text-slate-700 dark:text-slate-300 cursor-pointer select-none" htmlFor="nominal_harga">
                          Apakah nominal harga dirubah?
                        </label>
                      </div>
                    </div>

                    <div className={`${isSelected ? `hidden` : ``}`}>
                      {isOpenEditTrx && (
                        <ImageComponent
                          onClick={() => setOpenImage(true)}
                          className={'max-w-[80px]  hover:scale-110 cursor-pointer'}
                          width={'80px'}
                          height={'80px'}
                          style={{ objectFit: 'cover' }}
                          src={
                            idEditPembelian.gambar === null ? '' : `${imageBaseUrl}${idEditPembelian.gambar[0].asli}`
                          }
                        />
                      )}
                    </div>
                    <div className="mb-3 mt-3">
                      <div>
                        <div className={`mt-2 flex gap-4 p-2  ${selectImage.length === 0 ? 'hidden' : ''}`}>
                          {selectImage.map((image, index) => (
                            <div key={index} className="relative group">
                              <button
                                type="button"
                                onClick={() => setSelectImage(selectImage.filter((e) => e !== image))}
                                className="absolute -top-2 -right-2 bg-white dark:bg-slate-800 text-red-500 shadow-md rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                              >
                                <IconX width={16} height={16} />
                              </button>
                              <img className="w-24 h-24 object-cover rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm" src={image} key={index} alt="Preview" />
                            </div>
                          ))}
                        </div>
                        <input
                          type="file"
                          required
                          onChange={handleImageChange}
                          className="file:bg-slate-100 dark:file:bg-slate-800 file:border-0 file:rounded-md file:mr-4 file:py-2 file:px-4 file:text-sm file:font-semibold file:text-slate-700 dark:file:text-slate-300 hover:file:bg-slate-200 dark:hover:file:bg-slate-700/50 file:transition-colors file:cursor-pointer w-full text-sm text-slate-500 dark:text-slate-400 bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-lg p-2 focus:outline-none"
                          accept="image/png, image/jpeg, image/webp"
                        />
                      </div>
                    </div>

                    <div className="mt-6 pt-5 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
                      <button
                        type="button"
                        className="px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-200 dark:focus:ring-offset-slate-900 dark:focus:ring-slate-700"
                        onClick={closeModalEditTrx}
                      >
                        Batal
                      </button>
                      <button
                        type="submit"
                        className="px-5 py-2.5 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 dark:bg-amber-500 dark:hover:bg-amber-600 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 dark:focus:ring-offset-slate-900 disabled:opacity-70 flex items-center justify-center min-w-[100px]"
                        onClick={editTrxPembelian}
                        disabled={submitPembelian}
                      >
                        {submitPembelian ? (
                           <>
                             <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                             Proses...
                           </>
                        ) : 'Simpan Perubahan'}
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
